import { media } from '@atlaskit/primitives/responsive';
import { token } from '@atlaskit/tokens';
import { BodyLarge, FluidContainer, H1, Skeleton } from '@atlassian/mpac-primitives';
import { styled } from '@compiled/react';

const sectionHeight = {
  minHeight: '368px',

  [media.below.md]: {
    minHeight: '317px',
  },

  [media.below.sm]: {
    minHeight: '504px',
  },
};

export const HeroContainer = styled(FluidContainer)({
  ...sectionHeight,

  display: 'grid',
  gridTemplateColumns: 'repeat(12, 1fr)',
  gridGap: token('space.400'),
  padding: `${token('space.500')} 0 ${token('space.800')} 0`,

  [media.below.md]: {
    gridTemplateColumns: 'repeat(6, 1fr)',
    gridGap: token('space.300'),
  },

  [media.below.sm]: {
    display: 'flex',
    flexDirection: 'column',
    gap: token('space.200'),
    padding: `${token('space.400')} 0 ${token('space.500')} 0`,
  },
});

export const ContentContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gridColumn: '2 / 9',

  [media.below.md]: {
    gridColumn: '1 / 5',
  },

  [media.below.sm]: {
    gap: token('space.200'),
  },
});

export const Heading = styled(H1)({
  margin: `${token('space.400')} 0 ${token('space.300')} 0`,

  [media.below.sm]: {
    margin: 0,
  },
});

export const Description = styled(BodyLarge)({
  marginTop: 0,
});

export const ImageContainerDesktop = styled.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gridColumn: '9 / 12',

  [media.below.md]: {
    gridColumn: '5 / 7',
  },

  [media.below.sm]: {
    display: 'none',
  },
});

export const ImageContainerMobile = styled.div({
  display: 'flex',
  justifyContent: 'center',
  padding: `${token('space.200')} ${token('space.600')}`,

  [media.above.sm]: {
    display: 'none',
  },
});

export const Image = styled.img({
  height: 'auto',
  width: '100%',
});

export const HeroSkeleton = styled(Skeleton)({
  ...sectionHeight,
});
